export default __webpack_public_path__ + "static/media/Group157.92b09fb4.png";